import { useHistory } from "react-router-dom";
import { resolveMockup } from "../../../utils";
import { CallTelemed } from "../../useCallAPI";

export const useLogout = () => {
  const history = useHistory();

  const [{ data, loading, error }, fire] = CallTelemed<{ status: number }>(
    {
      url: `/v2/auth/logout`,
      method: "POST",
    },
    { manual: true }
  );
  return {
    result_logout: data?.status,
    loading_logout: loading,
    error_logout: error,
    fire_logout: () => {
      return resolveMockup({ data: { status: 1 } }).then(() => {
        localStorage.clear();
        history.push("/");
      });
      // return fire().then(() => {
      //   localStorage.clear();
      //   history.push("/");
      // });
    },
  };
};
